import 'css-chunksrc/client/scenes/zone/contextualMenu/styles.scss';export default {
  "contextualMenu": "_contextualMenu_1w3e1_1",
  "menuIcon": "_menuIcon_1w3e1_7",
  "menu": "_menu_1w3e1_7",
  "menuItem": "_menuItem_1w3e1_16",
  "openedMenu": "_openedMenu_1w3e1_25",
  "icon": "_icon_1w3e1_40",
  "removeAction": "_removeAction_1w3e1_46"
};